import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/")({
  loader: () => {
    throw redirect({
      to: "/dashboard/inbox",
      search: { domainId: undefined, aliasId: undefined, direction: "inbound", q: undefined },
    });
  },
});
